import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ContactForm from './components/contactForm';
import ContactList from './components/contactList';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Button,
  Input,
  UncontrolledDropdown,
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { aPI_Contacts } from '../../../../constants/APIs';
import Pagination from '../../../../containers/pages/Pagination';

const getContact = (props) => {
  if (props?.original?.name && props?.original.name !== null)
    return (
      <p>
        <i className={`iconsminds-user`}></i> <b>{props?.original.name}</b>
      </p>
    );
  else if (props?.original?.email && props?.original.email !== null)
    return (
      <p>
        <i className={`iconsminds-at-sign`}></i> <b>{props?.original.email}</b>
      </p>
    );
  else if (props?.original?.phone && props?.original.phone !== null)
    return (
      <p>
        <i className={`simple-icon-phone`}></i> <b>{props?.original.phone}</b>
      </p>
    );
};

const contactTableColumns = [
  {
    Header: (
      <p>
        <i className="simple-icon-people"></i> Contact
      </p>
    ),
    accessor: 'name',
    Cell: (props) => <p className="ml-3">{getContact(props)}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar`}></i> First Acitivity
      </p>
    ),
    accessor: 'firstActivityDate',
    Cell: (props) => <p className="ml-4">{props?.original?.firstActivity}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar`}></i> Recent Acitivity
      </p>
    ),
    accessor: 'lastActivityDate',
    Cell: (props) => (
      <p className="ml-4">
        {props?.original?.lastActivity === 'Unknown'
          ? props?.original?.firstActivity
          : props?.original?.lastActivity}
      </p>
    ),
  },
  {
    Header: (
      <p>
        {' '}
        <i className="iconsminds-yes"></i> Marketing Consent
      </p>
    ),
    accessor: 'consent',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-settings`}></i> Last Channel
      </p>
    ),
    accessor: 'lastChannel',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: '',
    Cell: (props) => (
      <Button
        outline
        size="xs"
        color="primary"
        className="ml-4"
        onClick={() =>
          (window.location.href =
            '/app/pages/contact-details/' + props?.original?.contactId)
        }
      >
        <i className={`simple-icon-action-redo`}></i>
        {'  '}
        Open Contact
      </Button>
    ),
  },
];

function Index({ propertyId }) {
  const [addContact, setEditContact] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(10);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [contact, setContact] = useState();

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  const toggle = () => setEditContact(!addContact);

  const onChangePage = (page) => setcurrentPage(page);

  useEffect(() => {
    handleContactLoad();
  }, [propertyId, currentPage, SelectedPageSize, search]);

  const handleContactLoad = () => {
    AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}?groupId=${getGroupID()}&propertyId=${propertyId}&search=${search}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
    }).then((res) => {
      console.log(res.data);
      setTotalItems(res.data.totalItems);
      setTotalPages(res.data.totalPages);
      setContactsList(res.data?.contacts);
    });
  };

  const onSearchKey = (e) => {
    //if (e.key === "Enter") {
    setcurrentPage(1);
    setSearch(e.target.value.toLowerCase());
    // LoadBmbData();
    //}
  };

  const handleSave = (body) => {
    AxiosAPI({
      method: 'POST',
      url: `${aPI_Contacts}`,
      data: body,
    }).then((res) => {
      toggle();
      handleContactLoad();
    });
  };
  return (
    <Fragment>
      <Row className="mb-3">
        <Colxx xxs="12" className="mb-3">
          <div className="float-md-left">
            <Button color="primary" outline size="xs" onClick={toggle}>
              + Contact
            </Button>
          </div>
          <div className="float-md-right">
            <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-dark" size="xs">
                {SelectedPageSize}
              </DropdownToggle>
              <DropdownMenu right>
                {pageSizes.map((size, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => changePageSize(size)}
                    >
                      {size}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div className="float-md-right mr-3">
            <div
              className="search-sm d-inline-block float-md-left mr-3 mb-1 align-top"
              style={{ width: '100%' }}
            >
              <Input
                type="text"
                name="keyword"
                id="search"
                placeholder="Search"
                onKeyPress={(e) => onSearchKey(e)}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          {contactList.length > 0 && (
            <ContactList
              handleContactLoad={handleContactLoad}
              propertyId={propertyId}
              columns={contactTableColumns}
              data={contactList}
            ></ContactList>
          )}
        </Colxx>{' '}
        <Colxx xxs="12" className="mb-3">
          <Pagination
            currentPage={currentPage}
            totalPage={TotalPages}
            onChangePage={(i) => onChangePage(i)}
          />{' '}
        </Colxx>
      </Row>
      {addContact && (
        <ContactForm
          toggle={toggle}
          visible={addContact}
          propertyId={propertyId}
          handleSubmit={handleSave}
        ></ContactForm>
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};
export default injectIntl(connect(mapStateToProps, {})(Index));
